'use client';

import LogoIcon from '@/src/v2/assets/icons/LogoIcon';
import Button from '@/src/v2/components/Button/Button';
import { useAppSelector } from '@/src/v2/hooks/useAppSelector/UseAppSelector';
import { useIsSidebarOpenSelector } from '@/src/v2/store/selectors';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const isMenuOpen = useAppSelector(useIsSidebarOpenSelector);

  return (
    <div
      className="vCenterFirst"
      style={{
        paddingLeft: isMenuOpen ? `15rem` : `4.25rem`,
        textAlign: 'center',
      }}
    >
      <div
        className="vCenter"
        style={{ width: `calc(100% - ${isMenuOpen ? `15rem` : `4.25rem`})` }}
      >
        <LogoIcon width={100} height={30} />
        <h2>ERROR</h2>
        <h4>Something Went Wrong.</h4>
        <h4>Let’s Go Home and Try Again!</h4>
        <Button
          label={`Return to Homepage`}
          type={'primary-v2'}
          onClick={() => (window.location.href = '/')}
        />
      </div>
    </div>
  );
}
